<template>
  <div>
    <div class="bigTitle">亚洲 Panels</div>
    <div class="box">
      <div class="value physicians">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconMedtech.png" alt="">
        <div class="title">浩顿医生库</div>
        <div class="text">
          <div class="one">
             我们有一个严格的验证过程，以确保每个HCP小组成员是真实的，可靠的，可用的。
          </div>
          <div class="two">
           没有合适的人参与，一个项目是不可能成功完成的。招募成功不仅仅是追踪你的精确目标并说服他们参与你的学习。当研究人员与这些医生见面时，这些医生必须能够清楚地表达自己的观点，并且对该主题知识渊博。
          </div>
        </div>
        <div class="more" @click="toPath('/cn/physicians?source=webtable')">
           下载我们的 Panel Book ＞
        </div>
      </div>
      <div class="value patient" >
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconHealthcare.png" alt="">
        <div class="title">浩顿患者库</div>
        <div class="text">
          <div class="one">
            患者是医疗过程中的关键利益相关者和决策者。他们在医疗/医疗技术产品开发过程中也有重要的投入。

          </div>
          <div class="two">
           利用我们专有的HCP小组、亚洲医生小组联盟和患者支持团体/非政府组织，我们建立了一个庞大的患者资源库，涵盖关键医疗指标。该资源用于支持我们的客户在亚洲进行患者研究。
          </div>
        </div>
        <div class="more" @click="toPath('/cn/patients?source=webtable')">
           下载我们的 Panel Book ＞
        </div>
      </div>
      <div class="value consumer">
        <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconConsumer.png" alt="">
        <div class="title">浩顿消费者库</div>
        <div class="text">
          <div class="one">
            浩顿有236万真实的会员，他们经过仔细筛选和审查，可以为你的项目提供建议。
          </div>
          <div class="two">
           我们的专业研究专家团队积极管理我们的资源库会员，以确保高标准的服务，监控他们的参与和响应，并通过持续的数据分析、内部调查和会员满意度调查确保他们积极参与。这确保了我们按照您的项目要求找到最合适的消费者。

          </div>

        </div>
        <div class="more" @click="toPath('/cn/consumer?source=webtable')">
          下载我们的 Panel Book ＞
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bigTitle{
  font-size: 40px;
  padding: 20px 120px 0;
  font-weight: 700;
}
.box {
  display: flex;
  justify-content: center;
  justify-content: space-between;
  margin: 30px 120px;
  .value {
    width: 32%;
    background-color: #2cb1e9;
  position: relative;

    // border: 1px solid #000;
    padding: 20px 20px 50px;
    color: #fff;
    .title {
      font-size: 20px;
      font-weight: 700;
    }
    img {
      width: 80px;
    }
    .text {
      .one,
      .two {
        margin-top: 10px;
      }
    }
    .more {

            position: absolute;
  bottom: 15px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .bigTitle{
    font-size: 80px;
  }
  .box{
    flex-wrap: wrap;
    .value{
      width: 100%;
      padding: 30px;
      margin-bottom: 20px;
      padding-bottom: 150px;
      .title{
        font-size: 75px;
      }
     
    
        img{
          width: 400px;
        }
     
      .text{
        font-size: 70px;
      }
      .more{
        font-size: 70px;
      }
    }
  }
}
</style>